import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import AutoScroller from '../components/AutoScroller';

function firstThumb(project) {
  const m0 = Array.isArray(project?.media) ? project.media[0] : null;
  if (!m0) return '';
  return m0.image || m0.src || '';
}

export default function HomePage() {
  const { data, loading } = useData();

  useEffect(() => {
    document.body.classList.add('page-index');
    return () => document.body.classList.remove('page-index');
  }, []);

  useEffect(() => {
    if (data) {
      document.title = data.pages?.index?.meta?.title || 'Preeyanka Mondal — Portfolio';
    }
  }, [data]);

  if (loading || !data) return null;

  const page = data.pages?.index || {};
  const hero = page.hero || {};
  const work = data.work || [];
  const clients = page.clients || [];

  const heroBgStyle = hero.backgroundImage
    ? { '--home-hero-bg': `url("${hero.backgroundImage}")` }
    : {};

  return (
    <main className="home">
      {/* Hero */}
      <section className="hero hero--img hero-wrap" id="homeHero" style={heroBgStyle}>
        <div className="wrap hero-content" role="banner">
          <h1 className="hero-title hero-title--big">{hero.title}</h1>
          <div className="hero-sub">{hero.subtitle}</div>
        </div>
      </section>

      {/* Featured Work */}
      <section id="featuredWork" className="featured">
        <div className="wrap">
          <h2 className="section-title">{page.sectionTitle || 'Featured work'}</h2>
          <section className="featured-grid" aria-label="Project highlights">
            {work.slice(0, 6).map((project, i) => {
              const thumb = firstThumb(project);
              const alt = project?.media?.[0]?.alt || project.title || 'Project';
              return (
                <Link className="work-card" to={`/work/${project.id}`} key={project.id}>
                  <div className="work-thumb">
                    {thumb && (
                      <img
                        loading={i === 0 ? 'eager' : 'lazy'}
                        decoding="async"
                        src={thumb}
                        alt={alt}
                      />
                    )}
                  </div>
                  <div className="work-meta">
                    <p className="work-title">{project.title}</p>
                    <p className="work-sub">{project.subtitle}</p>
                  </div>
                </Link>
              );
            })}
          </section>
        </div>
      </section>

      {/* Brands Strip */}
      <section className="brands-strip" aria-label="Brands I've worked with">
        <div className="wrap">
          <p className="brands-title">{page.clientsTitle || "Brands I've worked with"}</p>
          <AutoScroller
            items={clients}
            rowClass="brands-row"
            itemRenderer={(item, key) => (
              <div className="home-brand-logo" title={item.name} key={key} style={{ flexShrink: 0 }}>
                <img loading="lazy" decoding="async" src={item.logo} alt={item.name} />
              </div>
            )}
          />
        </div>
      </section>
    </main>
  );
}
